module.exports = __webpack_public_path__ + "img/dp13.27fe34b6.jpeg";